import { createTestIds } from '../../utils';

export const getLightboxTestIds = createTestIds('lightbox', [
  'content',
  'name',
  'metadata',
  'download',
  'open-in-new-tab',
  'close',
  'prev',
  'next',
  'pagination',
  'non-previewable-download',
  'link'
] as const);
